import React, { useState, useEffect, useMemo, useCallback } from "react";
import { ListBox } from "primereact/listbox";
import { useNavigate, useLocation } from "react-router-dom";
import { Avatar } from "primereact/avatar";
import { Sidebar } from "primereact/sidebar";
import { Button } from "primereact/button";
import { useDispatch, useSelector } from "react-redux";
import * as loginSelector from "../../pages/Login/LoginSelector";
import * as profileSelector from "../../pages/Profile/ProfileSelector";
import "./Sidebar.scss";
import Property1Dashboard from "../../assets/Property 1=Dashboard, Property 2=Off (1).png";
import Property1Hamburger from "../../assets/Property 1=Hamburger.png";
import Property1DashboardActive from "../../assets/Property 1=Dashboard, Property 2=On.png";
import Property1LogoutActive from "../../assets/Property 1=Logout, Property 2=On (1).png";
import Property1Logout from "../../assets/Property 1=Logout, Property 2=Off.png";
import activityMasterImg from "../../assets/activityMasterImg.png";
import trainingMaster from "../../assets/trainingMaster.png";
import activeschemes from "../../assets/activeschemes.png";
import districtmater from "../../assets/districtmater.jpg";
import subCentreImg from "../../assets/subCentreImg.png";

const LOGOUT_KEYS = [
  "userToken", "userRole", "refreshToken", "entireToken",
  "phcId", "stateName", "stateId", "areaId", "districtId",
  "districtName", "talukaId", "talukaName", "accessMenus", "lgbId",
  "access_level_id","firstname","lastname","rolename"
];

const SideBar = ({ menus }) => {
  const [visible, setVisible] = useState(false);
  const [selectedButton, setSelectedButton] = useState("dashboard");
  const [hoveredButton, setHoveredButton] = useState(null);
  const userCode = useSelector(loginSelector.getUserCode);
  const profileData = useSelector(profileSelector.getProfileInfo);
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const role = sessionStorage.getItem("rolename");
  const userFirstName = sessionStorage.getItem("firstname") || "";
  const userLastName = sessionStorage.getItem("lastname") || "";
  const firstNameInitial = userFirstName.charAt(0).toUpperCase();
  
  const toggleSidebar = () => setVisible((prev) => !prev);
  const clearSessionAndLogout = () => {
    LOGOUT_KEYS.forEach((key) => sessionStorage.removeItem(key));
    setTimeout(() => {
      navigate("/login");
      window.location.reload(); 
    }, 100);
  };
  const handleButtonClick = (buttonName, route) => {
    setVisible(false);
    setHoveredButton(null);
    setSelectedButton(buttonName);
    if (buttonName === "logout") {
      clearSessionAndLogout();
    } else {
      navigate(route);
    }
  };
  const sidebarItems = useMemo(() =>
    menus.filter((menu) => menu.hasAccess).map((menu) => {
      
      const images = {
        dashboard: [Property1Dashboard, Property1DashboardActive],
        coursecategory: [activityMasterImg, activityMasterImg],
        courses: [activityMasterImg, activityMasterImg],
        courseFiles: [activityMasterImg, activityMasterImg],
        questions: [subCentreImg, subCentreImg],
        quizzes: [activeschemes, activeschemes],
        topics: [districtmater, districtmater],
        module: [trainingMaster, trainingMaster],
        logout: [Property1Logout, Property1LogoutActive],
      };
      const [image, activeImage] = images[menu.menuName] || [null, null];
      return {
        label: menu.menuLabel,
        value: menu.route.slice(1),
        image,
        activeImage,
      };
    }), [menus]
  );

  const isButtonHighlighted = useCallback((button) => {
    const lowerPath = location.pathname.toLowerCase();
    return (
      lowerPath.includes(`/${button.value?.toLowerCase()}`) ||
      lowerPath.includes(`/${button.label?.toLowerCase()}`) ||
      (Array.isArray(button.children) &&
        button.children.some((child) => isButtonHighlighted(child)))
    );
  }, [location.pathname]);

  useEffect(() => {
    sidebarItems.find((item) => isButtonHighlighted(item));
  }, [location.pathname, sidebarItems, isButtonHighlighted]);

  const renderProfilePhoto = () => {
    if (!profileData?.profilePhoto) {
      return (
        <Avatar
          label={firstNameInitial}
          size="xlarge"
          style={{
            backgroundColor: "rgb(222, 226, 230)",
            color: "#1D2965",
            fontWeight: "bold",
            fontSize: "1.75rem",
            marginLeft: "4.5rem",
          }}
          data-testid="avatar-placeholder"
        />
      );
    }
    const src = typeof profileData.profilePhoto === "string"
      ? profileData.profilePhoto
      : URL.createObjectURL(profileData.profilePhoto);
    return (
      <img
        src={src}
        alt="Selected"
        className="image-style"
        data-testid="profile-photo"
      />
    );
  };

  const itemTemplateFun = (option) => (
    <Button
      size="large"
      onMouseEnter={() => setHoveredButton(option.value)}
      onMouseLeave={() => setHoveredButton(null)}
      onClick={() => handleButtonClick(option.value, `/${option.value.toLowerCase()}`)}
      className={`sidebar-button ${
        selectedButton === option.value || hoveredButton === option.value ? "active" : ""
      }`}
      data-testid={`sidebar-button-${option.value.toLowerCase()}`}
    >
      <div className="flex flex-row flex-wrap items-center gap-1">
        <img
          className="flex list-img"
          src={
            selectedButton === option.value || hoveredButton === option.value
              ? option.activeImage
              : option.image
          }
          alt=""
        />
        <div className="flex menu-text">{option.label}</div>
      </div>
    </Button>
  );

  const renderSidebarContent = () => (
  <div className="sidebar-content">
    {/* Fixed top section */}
    <div className="sidebar-header z-1">
      <p className="text-xl text-center" style={{ color: "#E03581", marginLeft: '3.5rem', marginTop: '2rem', fontSize: '1.4rem'}}>
        NHM LMS
      </p>
      <div className="align-items-center justify-content-center">
        {renderProfilePhoto()}
        <h5 className="asha-name">
          {userFirstName} {userLastName}
        </h5>
        <h2 className="asha-designation text-sm">{role}</h2>
      </div>
      <hr className="hr-line" />
    </div>

    {/* Scrollable menu section */}
    <div className="mt-1 sidebar-menu">
  <ListBox
    className="sidebar-listbox"
    options={sidebarItems}
    onChange={(e) => handleButtonClick(e.value, `/${e.value.toLowerCase()}`)}
    optionLabel="label"
    itemTemplate={itemTemplateFun}
  />
</div>

  </div>
);


  return (
    <div className="fixLayout">
      <div className="inline-flex" data-testid="sidebar">
        <div className="hamburger-wrapper">
          <Button
            className="hamburger-button"
            data-testid="toggleSidebarButton"
            onClick={toggleSidebar}
          >
            <img
              src={Property1Hamburger}
              style={{ width: "30%", height: "40%" }}
              alt="Icon"
            />
          </Button>
          <Sidebar
            className="side"
            visible={visible}
            onHide={toggleSidebar}
            showCloseIcon={!visible}
            modal={false}
            style={{ boxShadow: "none" }}
          >
            {renderSidebarContent()}
          </Sidebar>
        </div>
        <div className="sidebar-wrapper">
          <div className="desktop-sidebar">{renderSidebarContent()}</div>
        </div>
      </div>
    </div>
  );
};

export default SideBar;